module.exports = __webpack_public_path__ + "img/folder-dark-blue.91c4f667.svg";